import { Application } from "../types/Application";
import { Contact, EvaluationStatus } from "../types/Contact";

/*
null => Non lu
1 => Lu
2 => Remerciee
3 => En attente
4 => A l etude
5 => Favorable
*/
const applicationStatus: { [status: string]: EvaluationStatus } = {
    "1": EvaluationStatus.CANDIDATURE,
    "2": EvaluationStatus.REMERCIEE,
    "3": EvaluationStatus.EN_ATTENTE,
    "4": EvaluationStatus.EN_ETUDE,
    "5": EvaluationStatus.FAVORABLE
}

export const convertApplicationToContact = (application: Application): Contact => {
    const candidatureTimestamp = application.thedate?.match(/\d+/)?.[0] ?? null;
    const responseTimestamp = application.date_reponse?.match(/\d+/)?.[0] ?? null;

    const candidatureDate = candidatureTimestamp !== null ? new Date(parseInt(candidatureTimestamp)) : new Date();
    const responseDate = responseTimestamp !== null ? new Date(parseInt(responseTimestamp)) : undefined;

    const validPercentage = Math.min(100, Math.max(0, application.gest_score));

    const rating = Math.round(validPercentage / 20);

    return {
        id: application.id_de_job_cand + "",
        firstname: application.contact_prenom,
        lastname: application.contact_nom,
        profile: "",
        candidatureDate,
        responseDate,
        coordinates: {
            email: application.contact_email,
            phone: application.contact_tel1,
            region: application.pays
        },
        evaluation: {
            status: application.gest_etat !== null ? applicationStatus[application.gest_etat] : EvaluationStatus.CANDIDATURE,
            rating,
            notes: application.gest_note
        },
        cv: application.cv_fichier,
        motivationLetter: !!application.id_de_cv_lettre || !!application.message
    }
}

export const convertRatingToScore = (rating?: number) => {
    return rating ? Math.min(100, Math.max(0, (rating * 20))) : null;
}

export const convertStatusToEtat = (status: EvaluationStatus) => {
    return Object.keys(applicationStatus).find(etat => applicationStatus[etat] === status);
}